import React, { useState, useEffect, useRef } from "react";
import EditAtdLayout from "../../components/EditAtdLayout";
import "./edit-atd.css";
import {
  FaUsers,
  FaEdit,
  FaCheckCircle,
  FaWpforms,
  FaEllipsisV,
  FaClock,
  FaPlus,
} from "react-icons/fa";
import {
  Row,
  Col,
  Button,
  Form,
  Modal,
  Dropdown,
} from "react-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { IoEye } from "react-icons/io5";
import axios from "axios";
import { MdAccessTime, MdDelete } from "react-icons/md";
import { FaDownload, FaPrint } from "react-icons/fa";
import { TbReplaceFilled } from "react-icons/tb";
import { formatInTimeZone } from "date-fns-tz";
import { getPayrollPeriod, getRecentPayrollPeriods } from "../../utils/payrollPeriod";
import { ROLES } from "../../config/roles";

export default function MonthlyAtd() {
  const { userId } = useParams();
  const navigate = useNavigate();

  const TIMEZONE = "Europe/London";

  const formatTimeInUK = (dateValue) => {
    if (!dateValue) return "—";
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return "Invalid";
    return formatInTimeZone(date, TIMEZONE, "hh:mm a");
  };

  const [attendanceData, setAttendanceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [employee, setEmployee] = useState({ name: "", userId: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [selectedDocId, setSelectedDocId] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedDocUrl, setSelectedDocUrl] = useState("");
  const [docCategory, setDocCategory] = useState("");

  const [earlyCloseDocs, setEarlyCloseDocs] = useState({});
  const [overtimeDocs, setOvertimeDocs] = useState({});
  const [lateDocs, setLateDocs] = useState({});

  // Payroll period state
  const [selectedPeriod, setSelectedPeriod] = useState(() => getPayrollPeriod());
  const [availablePeriods] = useState(() => getRecentPayrollPeriods(6, 2));

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});

  const [showEarlyLeaveApprovalModal, setShowEarlyLeaveApprovalModal] = useState(false);
  const [showLateApprovalModal, setShowLateApprovalModal] = useState(false);
  const [showOvertimeApprovalModal, setShowOvertimeApprovalModal] = useState(false);

  const [approvalData, setApprovalData] = useState({});
  const [hrSignature, setHrSignature] = useState("");
  const [adminSignature, setAdminSignature] = useState("");
  const [applySingleDeduction, setApplySingleDeduction] = useState(false);

  const fileInputRef = useRef(null);
  const printRef = useRef(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);

  // Break History States
  const [showBreakTimesModal, setShowBreakTimesModal] = useState(false);
  const [breakList, setBreakList] = useState([]);
  const [breakLoading, setBreakLoading] = useState(false);
  const [selectedBreakItem, setSelectedBreakItem] = useState(null);

  const [hoveredBreaks, setHoveredBreaks] = useState({});

  const [allEmployees, setAllEmployees] = useState([]);
  const [sidebarLoading, setSidebarLoading] = useState(true);
  const [sidebarError, setSidebarError] = useState(null);
  const [breakSummary, setBreakSummary] = useState(null);

  // ===== NEW: Public Holiday Hours States =====
  const [showPublicHolidayHoursModal, setShowPublicHolidayHoursModal] = useState(false);
  const [publicHolidayHoursForm, setPublicHolidayHoursForm] = useState({
    date: null,
    hours: "",
    holidayName: "",
  });
  const [savingPublicHolidayHours, setSavingPublicHolidayHours] = useState(false);
  const [publicHolidaysInPeriod, setPublicHolidaysInPeriod] = useState([]);

  // ===== NEW: Render Auto Break Badge =====
  const renderAutoBreakBadge = (item) => {
    if (!item.isAutoBreakDeducted) return null;

    const totalUnpaid = (item.totalUnpaidBreakMinutes || 0) + (item.totalExcessUnpaidMinutes || 0);

    return (
      <div style={{ marginTop: "4px" }}>
        <span
          style={{
            backgroundColor: "#fff3cd",
            color: "#856404",
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "10px",
            fontWeight: "600",
            border: "1px solid #ffc107",
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <FaClock size={10} /> Auto: {item.totalPaidBreakMinutes || 0}m paid
          {totalUnpaid > 0 && (
            <span style={{ color: "#dc3545" }}>, {totalUnpaid}m unpaid</span>
          )}
        </span>
      </div>
    );
  };

  // ===== NEW: Render Break Deduction Notice =====
  const renderBreakDeductionNotice = (item) => {
    const deductionMinutes = item.breakDeductionMinutes || 0;
    if (deductionMinutes === 0) return null;

    return (
      <div style={{ marginTop: "2px" }}>
        <span
          style={{
            color: "#dc3545",
            fontSize: "10px",
            fontWeight: "700",
          }}
        >
          -{deductionMinutes} min deducted from hours
        </span>
      </div>
    );
  };

  // ===== Mark Absence States =====
  const [showMarkAbsenceModal, setShowMarkAbsenceModal] = useState(false);
  const [absenceFormData, setAbsenceFormData] = useState({
    status: "absent",
    leaveType: "",
    leaveReason: "",
  });
  const [markingAbsence, setMarkingAbsence] = useState(false);
  const [selectedDateForAbsence, setSelectedDateForAbsence] = useState(null);

  const role = localStorage.getItem("role");

  // ===== Helper: Role Check =====
  const canManageStatus =
    role === "admin" ||
    role === "HR" ||
    role?.toLowerCase() === ROLES.STAFF?.toLowerCase();

  const fetchAllEmployees = async () => {
    try {
      setSidebarLoading(true);
      setSidebarError(null);
      const res = await axios.get("https://backend.ems.uk.hiradentallab.com/api/user/employees");
      let employees = [];
      if (res.data && res.data.success === true && Array.isArray(res.data.data)) {
        employees = res.data.data;
      } else if (Array.isArray(res.data)) {
        employees = res.data;
      }
      // A–Z by name. trim() stops names saved with a leading space
      // (e.g. " Ehizojie Esene ") from jumping to the top of the list.
      employees.sort((a, b) => {
        const nameA = String(a.EmployeeName || a.name || "").trim();
        const nameB = String(b.EmployeeName || b.name || "").trim();
        return nameA.localeCompare(nameB, "en", { sensitivity: "base" });
      });
      setAllEmployees(employees);
    } catch (err) {
      console.error("Failed to fetch employees", err);
      setSidebarError("Could not load employees.");
      setAllEmployees([]);
    } finally {
      setSidebarLoading(false);
    }
  };

  const fetchEmployeeDetails = async () => {
    if (!userId) return;
    try {
      const response = await fetch(`https://backend.ems.uk.hiradentallab.com/api/user/user/${userId}`);
      if (!response.ok) throw new Error("Failed to fetch employee details");
      const data = await response.json();

      // ✅ FIX: the API returns the user object directly
      // (older APIs returned { success, employee }) – support both
      const emp = data.employee || data;
      if (emp && (emp.EmployeeName || emp.name)) {
        setEmployee({
          name: emp.EmployeeName || emp.name,
          userId: emp.userId || userId,
        });
      }
    } catch (error) {
      console.error("Error fetching employee details:", error);
      setEmployee({ name: "Employee Not Found", userId: userId });
    }
  };

  // ===== Generate all dates in payroll period =====
  const generatePeriodDates = (period) => {
    const dates = [];
    const start = moment(period.startDate);
    const end = moment(period.endDate);
    let current = start.clone();

    while (current.isSameOrBefore(end, "day")) {
      dates.push(current.clone());
      current.add(1, "day");
    }
    return dates;
  };

  // ===== Merge attendance data with all period dates =====
  const mergeAttendanceWithDates = (attendanceRecords, periodDates, publicHolidays = []) => {
    const attendanceMap = {};
    attendanceRecords.forEach((record) => {
      const dateKey = moment.tz(record.date, "Europe/London").format("YYYY-MM-DD");
      attendanceMap[dateKey] = record;
    });

    // ---------- FIXED: always use London timezone ----------
    const holidayMap = {};
    publicHolidays.forEach((h) => {
      const key = h.dayKey || moment.tz(h.date, "Europe/London").format("YYYY-MM-DD");
      holidayMap[key] = h;
    });
    // -------------------------------------------------------

    return periodDates.map((dateObj) => {
      const dateKey = dateObj.format("YYYY-MM-DD");
      const existingRecord = attendanceMap[dateKey];
      const isPublicHoliday = !!holidayMap[dateKey];
      const holidayInfo = holidayMap[dateKey] || null;

      if (existingRecord) {
        return {
          ...existingRecord,
          _dateKey: dateKey,
          _isGenerated: false,
          isPublicHoliday: existingRecord.isPublicHoliday || isPublicHoliday,
          publicHolidayHours: existingRecord.publicHolidayHours || 0,
          holidayName: holidayInfo?.holidayName || null,
        };
      }

      return {
        _id: `blank-${dateKey}`,
        _dateKey: dateKey,
        _isGenerated: true,
        userId: parseInt(userId),
        userName: employee.name,
        date: dateObj.toDate(),
        status: null,
        checkIn: null,
        checkOut: null,
        workedHours: "0",
        lateMinutes: 0,
        earlyCloseMinutes: 0,
        extraMinutes: 0,
        lateReason: null,
        earlyCloseReason: null,
        overtimeReason: null,
        scheduledBreakMinutes: 0,
        paidBreakMinutes: 0,
        breakDeductionMinutes: 0,
        totalPaidBreakMinutes: 0,
        totalUnpaidBreakMinutes: 0,
        leaveType: null,
        leaveReason: null,
        markedBy: null,
        isPublicHoliday,
        publicHolidayHours: 0,
        holidayName: holidayInfo?.holidayName || null,
      };
    });
  };

  const fetchAttendanceData = async () => {
    if (!userId) return;
    setLoading(true);
    setError(null);

    const { startDate, endDate } = selectedPeriod;

    try {
      const response = await fetch(
        `https://backend.ems.uk.hiradentallab.com/api/attendance/attendance/range/${userId}?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
      );

      if (!response.ok) throw new Error(`Failed to fetch attendance data.`);

      const data = await response.json();

      console.log("[FETCH ATD] Response:", {
        success: data.success,
        count: data.count,
        recordsCount: data.data?.length || 0,
        publicHolidays: data.publicHolidays?.length || 0,
      });

      const periodDates = generatePeriodDates(selectedPeriod);
      const publicHolidays = data.publicHolidays || [];

      setPublicHolidaysInPeriod(publicHolidays);

      let processedData = [];

      if (data.success && Array.isArray(data.data)) {
        const enrichedRecords = data.data.map((item) => ({
          ...item,
          lateReason: item.lateReason ?? "Not provided",
          earlyCloseReason: item.earlyCloseReason ?? "Not provided",
          overtimeReason: item.overtimeReason ?? "Not provided",
          lateSingleDeduction: item.lateSingleDeduction ?? false,
          earlyCloseSingleDeduction: item.earlyCloseSingleDeduction ?? false,
          lateHrSignature: item.lateHrSignature ?? null,
          lateAdminSignature: item.lateAdminSignature ?? null,
          earlyCloseHrSignature: item.earlyCloseHrSignature ?? null,
          earlyCloseAdminSignature: item.earlyCloseAdminSignature ?? null,
          overtimeHrSignature: item.overtimeHrSignature ?? null,
          overtimeAdminSignature: item.overtimeAdminSignature ?? null,
          scheduledBreakMinutes: item.scheduledBreakMinutes ?? 0,
          paidBreakMinutes: item.paidBreakMinutes ?? item.totalPaidBreakMinutes ?? 0,
          breakDeductionMinutes: item.breakDeductionMinutes ?? item.totalUnpaidBreakMinutes ?? 0,
          totalPaidBreakMinutes: item.totalPaidBreakMinutes ?? 0,
          totalUnpaidBreakMinutes: item.totalUnpaidBreakMinutes ?? 0,
          totalExcessUnpaidMinutes: item.totalExcessUnpaidMinutes ?? 0,
          autoTopUpUnpaidMinutes: item.autoTopUpUnpaidMinutes ?? 0,
          workedHours: item.workedHours || "0",
          status: item.status || "present",
          leaveType: item.leaveType || null,
          leaveReason: item.leaveReason || null,
          isAutoBreakDeducted: item.isAutoBreakDeducted || false,
          isPublicHoliday: item.isPublicHoliday || false,
          publicHolidayHours: item.publicHolidayHours || 0,
        }));

        processedData = mergeAttendanceWithDates(enrichedRecords, periodDates, publicHolidays);

        const newEarlyCloseDocs = {};
        const newOvertimeDocs = {};
        const newLateDocs = {};

        data.data.forEach((item) => {
          newEarlyCloseDocs[item._id] = item.earlyCloseDocs || null;
          newOvertimeDocs[item._id] = item.overtimeDocs || null;
          newLateDocs[item._id] = item.lateDocs || null;
        });

        setEarlyCloseDocs(newEarlyCloseDocs);
        setOvertimeDocs(newOvertimeDocs);
        setLateDocs(newLateDocs);
      } else {
        processedData = mergeAttendanceWithDates([], periodDates, publicHolidays);
      }

      setAttendanceData(processedData);
      setFilteredData(processedData);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      setError("Failed to load attendance records.");
      const periodDates = generatePeriodDates(selectedPeriod);
      const blankData = mergeAttendanceWithDates([], periodDates, []);
      setAttendanceData(blankData);
      setFilteredData(blankData);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllEmployees();
  }, []);

  useEffect(() => {
    fetchEmployeeDetails();
  }, [userId]);

  useEffect(() => {
    fetchAttendanceData();
  }, [userId, selectedPeriod]);

  const handleEmployeeClick = (emp) => {
    const targetUserId = emp.userId || emp.UserId || emp._id;
    if (!targetUserId) return;
    navigate(`/current-month-atd/${targetUserId}`);
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);
    const lowercased = searchValue.toLowerCase();
    const filtered = attendanceData.filter(
      (item) =>
        item.userName?.toLowerCase().includes(lowercased) ||
        moment(item.date).format("YYYY-MM-DD").toLowerCase().includes(lowercased) ||
        (item.status && item.status.toLowerCase().includes(lowercased))
    );
    setFilteredData(filtered);
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      filteredData.map((item, index) => ({
        SR: index + 1,
        "Day - Date": `${moment(item.date).format("ddd")} - ${moment(item.date).format("YYYY-MM-DD")}`,
        Status: item.status || "Not Recorded",
        "Leave Type": item.leaveType || "-",
        CheckIn: item.status === "present" ? formatTimeInUK(item.checkIn) : "-",
        CheckOut: item.status === "present" ? (item.checkOut ? formatTimeInUK(item.checkOut) : "N/A") : "-",
        WorkedHours:
          item.status === "present" || (item.status === "holiday" && item.leaveType === "paid")
            ? (item.workedHours || "0")
            : "0",
        "Public Holiday Hours": item.publicHolidayHours || 0,
        ScheduledBreak: item.status === "present" ? (item.scheduledBreakMinutes || 0) : "-",
        PaidBreak: item.status === "present" ? (item.paidBreakMinutes || 0) : "-",
        UnpaidBreak: item.status === "present" ? (item.breakDeductionMinutes || 0) : "-",
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
    XLSX.writeFile(workbook, `${employee.name}_Attendance.xlsx`);
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text(`${employee.name}'s Timesheet`, 20, 10);
    doc.autoTable({
      head: [["Day - Date", "Status", "In", "Out", "Hours", "PH Hours", "Sched", "Paid", "Unpaid"]],
      body: filteredData.map((item) => [
        `${moment(item.date).format("ddd")} - ${moment(item.date).format("YYYY-MM-DD")}`,
        item.status || "Not Recorded",
        item.status === "present" ? formatTimeInUK(item.checkIn) : "-",
        item.status === "present" ? (item.checkOut ? formatTimeInUK(item.checkOut) : "N/A") : "-",
        item.status === "present" || (item.status === "holiday" && item.leaveType === "paid")
          ? (item.workedHours || "0")
          : "0",
        item.publicHolidayHours || 0,
        item.status === "present" ? (item.scheduledBreakMinutes || 0) : "-",
        item.status === "present" ? (item.paidBreakMinutes || 0) : "-",
        item.status === "present" ? (item.breakDeductionMinutes || 0) : "-",
      ]),
    });
    doc.save(`${employee.name}_Timesheet.pdf`);
  };

  const handleShowModal = (item) => {
    setModalData(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalData({});
  };

  const handleViewDocument = (docUrl, item, category) => {
    if (!docUrl || !item || !item._id) {
      alert("Something went wrong.");
      return;
    }
    let formattedUrl = docUrl.startsWith("http")
      ? docUrl
      : `https://backend.ems.uk.hiradentallab.com${docUrl.startsWith("/uploads") ? docUrl : `/uploads/${docUrl}`}`;
    setSelectedDocUrl(formattedUrl);
    setSelectedDocId(item._id);
    setDocCategory(category);
    setShowViewModal(true);
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(selectedDocUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = selectedDocUrl.split("/").pop() || "document";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Download failed.");
    }
  };

  const handleFileReplace = async (e) => {
    const file = e.target.files[0];
    if (!file || !selectedDocId || !docCategory) {
      alert("No file selected or missing data.");
      return;
    }
    const formData = new FormData();
    formData.append("document", file);
    formData.append("uploadCategory", docCategory);
    try {
      const response = await fetch(
        `https://backend.ems.uk.hiradentallab.com/api/attendance/update-document/${selectedDocId}`,
        { method: "POST", body: formData }
      );
      const resData = await response.json();
      if (response.ok) {
        alert("Document replaced successfully!");
        setShowViewModal(false);
        fetchAttendanceData();
      } else {
        alert(resData.message || "Failed to replace document");
      }
    } catch (error) {
      alert("Error replacing file.");
    }
  };

  const resetApprovalData = () => {
    setApprovalData({});
    setHrSignature("");
    setAdminSignature("");
    setApplySingleDeduction(false);
  };

  const handleOpenLateApprovalForm = (item) => {
    if (item._isGenerated) return;
    resetApprovalData();
    const currentRole = localStorage.getItem("role");
    const hrHasApproved = !!item.lateHrSignature;
    const adminHasApproved = !!item.lateAdminSignature;
    setApprovalData({
      userName: item.userName || employee.name,
      userId: item.userId || employee.userId,
      date: new Date(item.checkIn).toLocaleDateString(),
      department: item.department || employee.department,
      type: "Late Arrival",
      minutes: item.lateMinutes || 0,
      reason: item.lateReason || "Not provided",
      attendanceId: item._id,
      singleDeduction: item.lateSingleDeduction || false,
      hrHasApproved,
      adminHasApproved,
      canEditHRSignature: currentRole === "HR" && !hrHasApproved,
      canEditAdminSignature: currentRole === "admin" && !adminHasApproved,
      currentRole,
    });
    setHrSignature(item.lateHrSignature || "");
    setAdminSignature(item.lateAdminSignature || "");
    setApplySingleDeduction(item.lateSingleDeduction || false);
    setShowLateApprovalModal(true);
  };

  const handleOpenEarlyLeaveApprovalForm = (item) => {
    if (item._isGenerated) return;
    resetApprovalData();
    const currentRole = localStorage.getItem("role");
    const hrHasApproved = !!item.earlyCloseHrSignature;
    const adminHasApproved = !!item.earlyCloseAdminSignature;
    setApprovalData({
      userName: item.userName || employee.name,
      userId: item.userId || employee.userId,
      date: new Date(item.checkIn).toLocaleDateString(),
      department: item.department || employee.department,
      type: "Early Leave",
      minutes: item.earlyCloseMinutes || 0,
      reason: item.earlyCloseReason || "Not provided",
      attendanceId: item._id,
      singleDeduction: item.earlyCloseSingleDeduction || false,
      hrHasApproved,
      adminHasApproved,
      canEditHRSignature: currentRole === "HR" && !hrHasApproved,
      canEditAdminSignature: currentRole === "admin" && !adminHasApproved,
      currentRole,
    });
    setHrSignature(item.earlyCloseHrSignature || "");
    setAdminSignature(item.earlyCloseAdminSignature || "");
    setApplySingleDeduction(item.earlyCloseSingleDeduction || false);
    setShowEarlyLeaveApprovalModal(true);
  };

  const handleOpenOvertimeApprovalForm = (item) => {
    if (item._isGenerated) return;
    resetApprovalData();
    const currentRole = localStorage.getItem("role");
    const hrHasApproved = !!item.overtimeHrSignature;
    const adminHasApproved = !!item.overtimeAdminSignature;
    setApprovalData({
      userName: item.userName || employee.name,
      userId: item.userId || employee.userId,
      date: new Date(item.checkIn).toLocaleDateString(),
      department: item.department || employee.department,
      type: "Overtime",
      minutes: item.extraMinutes || 0,
      reason: item.overtimeReason || "Not provided",
      attendanceId: item._id,
      hrHasApproved,
      adminHasApproved,
      canEditHRSignature: currentRole === "HR" && !hrHasApproved,
      canEditAdminSignature: currentRole === "admin" && !adminHasApproved,
      currentRole,
    });
    setHrSignature(item.overtimeHrSignature || "");
    setAdminSignature(item.overtimeAdminSignature || "");
    setApplySingleDeduction(false);
    setShowOvertimeApprovalModal(true);
  };

  const handleApprove = async (type) => {
    if (!role || (role !== "HR" && role !== "admin")) {
      alert("You do not have permission to approve this request.");
      return;
    }
    if (role === "HR" && !hrSignature) {
      alert("Please provide an HR signature before approving.");
      return;
    }
    if (role === "admin" && !adminSignature) {
      alert("Please provide an Admin signature before approving.");
      return;
    }
    try {
      const normalizedType = type === "earlyClose" ? "earlyClose" : type.toLowerCase();
      const updateData = {
        type: normalizedType,
        approve: role === "admin" ? true : undefined,
        semiApproved: role === "HR" ? true : undefined,
        deduct: normalizedType !== "overtime" && role === "admin" ? !applySingleDeduction : undefined,
        singleDeduction: normalizedType !== "overtime" && role === "admin" ? applySingleDeduction : undefined,
        hrSignature: role === "HR" ? hrSignature : undefined,
        adminSignature: role === "admin" ? adminSignature : undefined,
      };
      const response = await axios.put(
        `https://backend.ems.uk.hiradentallab.com/api/attendance/${approvalData.attendanceId}/deduct`,
        updateData,
        { headers: { "x-user-role": role } }
      );
      if (response.status === 200) {
        alert(`Attendance ${normalizedType} approved successfully!`);
        fetchAttendanceData();
        if (type === "late") setShowLateApprovalModal(false);
        if (type === "earlyClose") setShowEarlyLeaveApprovalModal(false);
        if (type === "overtime") setShowOvertimeApprovalModal(false);
        resetApprovalData();
      } else {
        alert("Failed to approve.");
      }
    } catch (error) {
      alert("Error approving record: " + (error.response?.data?.message || error.message));
    }
  };

  const handleDeleteClick = (item) => {
    if (item._isGenerated) return;
    setRecordToDelete(item);
    setShowDeleteModal(true);
  };

  const handleDeleteRecord = async () => {
    if (!recordToDelete) return;
    try {
      const response = await axios.post(
        "https://backend.ems.uk.hiradentallab.com/api/attendance/attendance/delete",
        { attendanceId: recordToDelete._id }
      );
      if (response.data.success) {
        setAttendanceData((prev) => prev.filter((i) => i._id !== recordToDelete._id));
        setFilteredData((prev) => prev.filter((i) => i._id !== recordToDelete._id));
        alert("Record deleted successfully!");
      }
    } catch (error) {
      alert("Error deleting record");
    } finally {
      setShowDeleteModal(false);
      setRecordToDelete(null);
    }
  };

  // ===== Break History Modal – loads breaks + saved break totals =====
  const handleOpenBreakTimesModal = async (item) => {
    if (item._isGenerated) return;
    setSelectedBreakItem(item);
    setShowBreakTimesModal(true);
    setBreakList([]);
    setBreakSummary(null);
    setBreakLoading(true);

    try {
      const date = moment(item.date).format("YYYY-MM-DD");
      const url = `https://backend.ems.uk.hiradentallab.com/api/attendance/breaks?userId=${item.userId}&date=${date}`;
      console.log("[BREAK MODAL] Fetching:", url);

      const res = await fetch(url);
      const json = await res.json();

      console.log("[BREAK MODAL] Response:", json);

      if (json.success) {
        const att = json.data.attendance || null;

        setBreakList(json.data.breaks || []);
        setBreakSummary(json.data.summary || null);

        // ✅ FIX: ALWAYS use the saved break totals from the server.
        // Before, they were only used when isAutoDeducted was true, so
        // admin-edited or time-edited days showed "No break records found"
        // even though minutes were deducted.
        if (att) {
          setSelectedBreakItem((prev) => ({
            ...prev,
            isAutoBreakDeducted: !!json.data.isAutoDeducted,
            hasManualBreak: !!json.data.hasManualBreak,
            totalBreakMinutes: att.totalBreakMinutes || 0,
            totalPaidBreakMinutes: att.totalPaidBreakMinutes || 0,
            totalUnpaidBreakMinutes: att.totalUnpaidBreakMinutes || 0,
            totalExcessUnpaidMinutes: att.totalExcessUnpaidMinutes || 0,
            breakDeductionMinutes: att.breakDeductionMinutes || 0,
            autoTopUpUnpaidMinutes: att.autoTopUpUnpaidMinutes || 0,
            workedHours: att.workedHours ?? prev?.workedHours ?? "0",
          }));
        }
      }
    } catch (err) {
      console.error("[BREAK MODAL] Error:", err);
    } finally {
      setBreakLoading(false);
    }
  };

  // Break Button Render
  const renderBreakButton = (item) => {
    if (item._isGenerated || item.status !== "present") return null;
    const isHovered = hoveredBreaks[item._id] || false;
    return (
      <Button
        variant="primary"
        size="sm"
        style={{
          background: isHovered
            ? "linear-gradient(135deg, #0069d9, #007bff)"
            : "linear-gradient(135deg, #007bff, #0056b3)",
          border: "none",
          color: "#fff",
          fontWeight: 600,
          padding: "5px 14px",
          borderRadius: "20px",
          boxShadow: isHovered
            ? "0 4px 12px rgba(0,123,255,0.4)"
            : "0 2px 6px rgba(0,123,255,0.2)",
          transition: "all 0.3s ease",
          display: "inline-flex",
          alignItems: "center",
          gap: "5px",
          fontSize: "0.8rem",
        }}
        onMouseEnter={() => setHoveredBreaks((prev) => ({ ...prev, [item._id]: true }))}
        onMouseLeave={() => setHoveredBreaks((prev) => ({ ...prev, [item._id]: false }))}
        onClick={() => handleOpenBreakTimesModal(item)}
      >
        <FaClock style={{ fontSize: "0.8rem" }} /> Details
      </Button>
    );
  };

  // ===== NEW: Open Public Holiday Hours Modal =====
  const handleOpenPublicHolidayHoursModal = (item) => {
    setPublicHolidayHoursForm({
      date: item.date,
      hours: item.publicHolidayHours > 0 ? String(item.publicHolidayHours) : "",
      holidayName: item.holidayName || "Public Holiday",
    });
    setShowPublicHolidayHoursModal(true);
  };

  // ===== NEW: Save Public Holiday Hours =====
  const handleSavePublicHolidayHours = async () => {
    if (!userId || !publicHolidayHoursForm.date) return;

    const hoursNum = parseFloat(publicHolidayHoursForm.hours);
    if (isNaN(hoursNum) || hoursNum < 0) {
      alert("Please enter a valid non-negative number for hours.");
      return;
    }

    setSavingPublicHolidayHours(true);
    try {
      const response = await axios.put(
        "https://backend.ems.uk.hiradentallab.com/api/attendance/public-holiday-hours",
        {
          userId: parseInt(userId),
          date: moment(publicHolidayHoursForm.date).format("YYYY-MM-DD"),
          hours: hoursNum,
        }
      );

      if (response.data.success) {
        setShowPublicHolidayHoursModal(false);
        setPublicHolidayHoursForm({ date: null, hours: "", holidayName: "" });
        alert("Public Holiday hours saved successfully!");
        await fetchAttendanceData();
      } else {
        alert(response.data.message || "Failed to save hours");
      }
    } catch (error) {
      alert(error.response?.data?.message || "Failed to save Public Holiday hours");
    } finally {
      setSavingPublicHolidayHours(false);
    }
  };

  const formatDateWithDay = (dateValue) => {
    const day = moment(dateValue).format("ddd");
    const date = moment(dateValue).format("DD MMM YYYY");
    return (
      <>
        <span style={{ fontWeight: "bold", color: "#0d6efd" }}>{day}</span>
        <br />
        <span style={{ fontSize: "12px", color: "#6c757d" }}>{date}</span>
      </>
    );
  };

  // ** TOTAL WORKED HOURS (only for present records) **
  const totalWorkedHours = filteredData.reduce((sum, item) => {
    if (item.status !== "present") return sum;
    const hours = parseFloat(item.workedHours);
    return sum + (isNaN(hours) ? 0 : hours);
  }, 0);

  // ** TOTAL PAID HOLIDAY HOURS (shift hours for paid holidays) **
  const totalPaidHolidayHours = filteredData.reduce((sum, item) => {
    if (item.status !== "holiday" || item.leaveType !== "paid") return sum;
    const hours = parseFloat(item.workedHours);
    return sum + (isNaN(hours) ? 0 : hours);
  }, 0);

  // ** NEW: TOTAL PUBLIC HOLIDAY HOURS **
  const totalPublicHolidayHours = filteredData.reduce((sum, item) => {
    const hours = parseFloat(item.publicHolidayHours) || 0;
    return sum + hours;
  }, 0);

  // ** GRAND TOTAL (present + paid holiday hours + public holiday hours) **
  const grandTotalHours = totalWorkedHours + totalPaidHolidayHours + totalPublicHolidayHours;

  // Payroll period navigation
  const goToPreviousPeriod = () => {
    const prevDate = new Date(selectedPeriod.startDate);
    prevDate.setDate(prevDate.getDate() - 1);
    setSelectedPeriod(getPayrollPeriod(prevDate));
  };

  const goToNextPeriod = () => {
    const nextDate = new Date(selectedPeriod.endDate);
    nextDate.setDate(nextDate.getDate() + 1);
    setSelectedPeriod(getPayrollPeriod(nextDate));
  };

  // ===== Mark Absence Functions =====
  const handleOpenMarkAbsenceModal = (date) => {
    setSelectedDateForAbsence(date);
    setAbsenceFormData({
      status: "absent",
      leaveType: "",
      leaveReason: "",
    });
    setShowMarkAbsenceModal(true);
  };

  const handleCloseMarkAbsenceModal = () => {
    setShowMarkAbsenceModal(false);
    setSelectedDateForAbsence(null);
    setAbsenceFormData({
      status: "absent",
      leaveType: "",
      leaveReason: "",
    });
  };

  const handleAbsenceFormChange = (field, value) => {
    setAbsenceFormData((prev) => {
      const updated = { ...prev, [field]: value };
      if (field === "status" && value === "holiday") {
        updated.leaveType = "paid";
      }
      if (field === "status" && value === "none") {
        updated.leaveType = "";
        updated.leaveReason = "";
      }
      return updated;
    });
  };

  const handleMarkAbsence = async () => {
    if (!userId || !selectedDateForAbsence) return;

    if (absenceFormData.status === "none") {
      const confirmed = window.confirm(
        "This will DELETE the attendance record for this date (including check-in/out times and any absence/holiday). You can then add fresh timings. Continue?"
      );
      if (!confirmed) return;
    }

    setMarkingAbsence(true);
    try {
      const response = await axios.post(
        "https://backend.ems.uk.hiradentallab.com/api/attendance/mark-absence",
        {
          userId: parseInt(userId),
          date: moment(selectedDateForAbsence).format("YYYY-MM-DD"),
          status: absenceFormData.status,
          leaveType: absenceFormData.status === "holiday" ? "paid" : (absenceFormData.leaveType || null),
          leaveReason: absenceFormData.leaveReason || null,
          markedBy: localStorage.getItem("role") || "admin",
        }
      );

      if (response.data.success) {
        setShowMarkAbsenceModal(false);
        setSelectedDateForAbsence(null);
        setAbsenceFormData({
          status: "absent",
          leaveType: "",
          leaveReason: "",
        });

        setTimeout(() => {
          alert(
            absenceFormData.status === "none"
              ? "Status cleared! You can now add timings for this date."
              : `User marked as ${absenceFormData.status} successfully!`
          );
        }, 300);

        await fetchAttendanceData();
      }
    } catch (error) {
      alert(error.response?.data?.message || "Failed to mark absence");
    } finally {
      setMarkingAbsence(false);
    }
  };

  // ===== Status Badge Helper =====
  const getStatusBadge = (status, leaveType) => {
    if (status === "leave" && leaveType === "sick") {
      return (
        <>
          <span
            style={{
              backgroundColor: "#ffc107",
              color: "#856404",
              padding: "4px 12px",
              borderRadius: "4px",
              fontSize: "11px",
              fontWeight: "600",
              textTransform: "uppercase",
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <span>⚠️</span> Sickness
          </span>
          <span
            style={{
              backgroundColor: "#fff",
              color: "#28a745",
              border: "1px solid #28a745",
              padding: "4px 12px",
              borderRadius: "4px",
              fontSize: "11px",
              fontWeight: "600",
              textTransform: "uppercase",
              marginLeft: "6px",
            }}
          >
            PAID
          </span>
        </>
      );
    }

    const statusConfig = {
      present: { bg: "#28a745", label: "Present" },
      absent: { bg: "#dc3545", label: "Absent" },
      leave: { bg: "#fd7e14", label: "Leave" },
      holiday: { bg: "#6f42c1", label: "Holiday" },
      weekoff: { bg: "#6c757d", label: "Week Off" },
    };

    const config = statusConfig[status];
    if (!config) return null;

    return (
      <span
        style={{
          backgroundColor: config.bg,
          color: "#fff",
          padding: "4px 12px",
          borderRadius: "4px",
          fontSize: "11px",
          fontWeight: "600",
          textTransform: "uppercase",
        }}
      >
        {config.label}
      </span>
    );
  };

  // ===== Leave Type Badge Helper =====
  const getLeaveTypeBadge = (leaveType) => {
    if (!leaveType) return null;

    const typeConfig = {
      paid: { bg: "#fff", color: "#28a745", border: "1px solid #28a745", label: "PAID" },
      unpaid: { bg: "#fff", color: "#dc3545", border: "1px solid #dc3545", label: "UNPAID" },
      sick: { bg: "#ffc107", color: "#856404", border: "none", label: "SICKNESS" },
      annual: { bg: "#0d6efd", color: "#fff", border: "none", label: "ANNUAL" },
      casual: { bg: "#ffc107", color: "#000", border: "none", label: "CASUAL" },
    };

    const config = typeConfig[leaveType] || { bg: "#6c757d", color: "#fff", border: "none", label: leaveType };

    return (
      <span
        style={{
          backgroundColor: config.bg,
          color: config.color,
          border: config.border,
          padding: "4px 12px",
          borderRadius: "4px",
          fontSize: "11px",
          fontWeight: "600",
          textTransform: "uppercase",
          marginLeft: "6px",
        }}
      >
        {config.label}
      </span>
    );
  };

  // ===== Check if date is in future =====
  const isFutureDate = (date) => {
    return moment(date).isAfter(moment(), "day");
  };

  // ===== Check if date is today =====
  const isToday = (date) => {
    return moment(date).isSame(moment(), "day");
  };

  // ===== Break History Modal content (always shows saved break totals) =====
  const renderBreakHistoryBody = () => {
    if (breakLoading) {
      return <p className="text-center">Loading breaks...</p>;
    }

    const b = selectedBreakItem || {};
    const paid = Number(b.totalPaidBreakMinutes) || 0;
    const unpaidTotal = Number(b.totalUnpaidBreakMinutes) || 0;
    const excess = Number(b.totalExcessUnpaidMinutes) || 0;
    const topUp = Number(b.autoTopUpUnpaidMinutes) || 0;
    const unpaidClocked = Math.max(0, unpaidTotal - topUp);
    const deducted = Number(b.breakDeductionMinutes) || unpaidTotal + excess;
    const totalBreak = Number(b.totalBreakMinutes) || 0;

    // Older records: minutes were deducted (breakDeductionMinutes / totalBreakMinutes)
    // without being split into paid / unpaid / excess. Show them as "Other deduction".
    const otherDeduction = Math.max(0, deducted - (unpaidTotal + excess));

    const hasAnyBreak =
      paid + unpaidTotal + excess > 0 ||
      deducted > 0 ||
      totalBreak > 0 ||
      breakList.length > 0;

    if (!hasAnyBreak) {
      return <p className="text-center text-muted">No break recorded for this day.</p>;
    }

    const sourceLabel = b.isAutoBreakDeducted
      ? "Auto-deducted (no break clocked)"
      : breakList.length > 0
        ? "Breaks clocked by employee"
        : otherDeduction > 0 && paid + unpaidTotal + excess === 0
          ? "Break deducted (recorded before break breakdown was saved)"
          : "Break set by admin";

    return (
      <>
        <div className="alert alert-info py-2 mb-3">
          <FaClock className="me-2" />
          <strong>{sourceLabel}</strong>
        </div>

        {/* Summary – always shown, including paid-only breaks */}
        <Row className="mb-3">
          <Col md={3} className="text-center">
            <div className="p-2 rounded" style={{ backgroundColor: "#d4edda" }}>
              <small className="text-muted">Paid</small>
              <div className="h4 mb-0 text-success">{paid}m</div>
            </div>
          </Col>
          <Col md={3} className="text-center">
            <div className="p-2 rounded" style={{ backgroundColor: "#fff3cd" }}>
              <small className="text-muted">Unpaid</small>
              <div className="h4 mb-0" style={{ color: "#856404" }}>{unpaidTotal}m</div>
            </div>
          </Col>
          <Col md={3} className="text-center">
            <div className="p-2 rounded" style={{ backgroundColor: "#f8d7da" }}>
              <small className="text-muted">Excess</small>
              <div className="h4 mb-0 text-danger">{excess}m</div>
            </div>
          </Col>
          <Col md={3} className="text-center">
            <div className="p-2 rounded" style={{ backgroundColor: "#fff", border: "1px solid #dc3545" }}>
              <small className="text-muted">Deducted</small>
              <div className="h4 mb-0 text-danger">-{deducted}m</div>
            </div>
          </Col>
        </Row>

        {/* Deduction that isn't split into paid / unpaid / excess (older records) */}
        {otherDeduction > 0 && (
          <div className="alert alert-secondary py-2">
            <strong>{otherDeduction} min break deducted</strong>
            <div style={{ fontSize: "13px" }}>
              This break was saved as a total only (no paid / unpaid split).
            </div>
          </div>
        )}

        {/* Clocked breaks, if any */}
        {breakList.length > 0 && (
          <div
            className="mb-3"
            style={{
              background: "#fff",
              borderRadius: "8px",
              padding: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            }}
          >
            <table className="table table-hover mb-0" style={{ fontSize: "0.9rem" }}>
              <thead style={{ backgroundColor: "#e9ecef" }}>
                <tr>
                  <th>#</th>
                  <th>Break In</th>
                  <th>Break Out</th>
                  <th>Total Duration</th>
                  <th>Breakdown</th>
                </tr>
              </thead>
              <tbody>
                {breakList.map((br, idx) => (
                  <tr key={br._id || idx}>
                    <td>{idx + 1}</td>
                    <td>{formatTimeInUK(br.breakIn)}</td>
                    <td>{formatTimeInUK(br.breakOut)}</td>
                    <td>
                      <span className="fw-bold">{br.durationMinutes} min</span>
                    </td>
                    <td>
                      {br.paidMinutes > 0 && (
                        <span className="badge bg-success me-1">Paid: {br.paidMinutes}m</span>
                      )}
                      {br.unpaidMinutes > 0 && (
                        <span className="badge bg-warning text-dark me-1">Unpaid: {br.unpaidMinutes}m</span>
                      )}
                      {br.excessUnpaidMinutes > 0 && (
                        <span className="badge bg-danger">Excess: {br.excessUnpaidMinutes}m</span>
                      )}
                      {!br.paidMinutes && !br.unpaidMinutes && !br.excessUnpaidMinutes && (
                        <span className="text-muted">—</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {breakSummary && (
              <div className="mt-3 p-2" style={{ backgroundColor: "#f8f9fa", borderRadius: "6px" }}>
                <div className="d-flex justify-content-between">
                  <span><strong>Total Break:</strong> {breakSummary.totalBreakMinutes} min</span>
                  <span className="text-success"><strong>Paid:</strong> {breakSummary.totalPaid} min</span>
                  <span className="text-danger"><strong>Unpaid:</strong> {breakSummary.totalUnpaid} min</span>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Remaining unpaid break added at clock-out */}
        {topUp > 0 && (
          <div className="alert alert-warning py-2">
            <strong>+{topUp} min unpaid break added automatically</strong>
            <div style={{ fontSize: "13px" }}>
              Unpaid break clocked: {unpaidClocked} min. The rest of the unpaid
              allowance was deducted because it wasn't taken.
            </div>
          </div>
        )}

        <div className="p-3 text-center" style={{ backgroundColor: "#e7f3ff", borderRadius: "8px" }}>
          <p className="mb-1"><strong>Worked Hours After Deduction:</strong></p>
          <p className="h3 mb-0" style={{ color: "#0d6efd" }}>{b.workedHours || "0"} hrs</p>
        </div>
      </>
    );
  };

  return (
    <EditAtdLayout>
      <div className="d-flex" style={{ height: "calc(100vh - 60px)", overflow: "hidden" }}>
        <div className="bg-light p-3" style={{ width: "280px", minWidth: "280px", overflowY: "auto", borderRight: "2px solid #dee2e6", backgroundColor: "#f8f9fa" }}>
          <h5 className="fw-bold mb-3" style={{ color: "#0d6efd" }}>
            <FaUsers className="me-2" />
            Employees
          </h5>
          {sidebarLoading ? (
            <p className="text-muted">Loading employees...</p>
          ) : sidebarError ? (
            <p className="text-danger">{sidebarError}</p>
          ) : allEmployees.length === 0 ? (
            <p className="text-muted">No employees found.</p>
          ) : (
            <div style={{ overflowY: "auto" }}>
              {allEmployees.map((emp, index) => {
                const empUserId = emp.userId || emp.UserId || emp._id;
                const isActive = String(empUserId) === String(userId);
                return (
                  <div
                    key={emp._id || emp.userId || index}
                    onClick={() => handleEmployeeClick(emp)}
                    className={`p-3 rounded mb-1 ${isActive ? "bg-primary text-white" : "hover-bg-light"}`}
                    style={{ cursor: "pointer", fontWeight: isActive ? "bold" : "normal", transition: "0.2s", borderLeft: isActive ? "4px solid #0d6efd" : "4px solid transparent" }}
                  >
                    {emp.EmployeeName || emp.name || "Unnamed Employee"}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="flex-grow-1 p-3" style={{ overflowY: "auto", backgroundColor: "#ffffff" }}>
          <h1 className="mb-3" style={{ color: "#0d6efd", fontWeight: "bold" }}>
            <FaUsers className="me-2" />
            {employee.name ? `${employee.name}'s` : "Employee"} Timesheet – {selectedPeriod.label}
          </h1>

          <Row className="mb-3 align-items-center">
            <Col md={1}>
              <Button variant="outline-primary" size="sm" onClick={goToPreviousPeriod}>◀</Button>
            </Col>
            <Col md={3}>
              <Form.Select
                value={selectedPeriod.label}
                onChange={(e) => {
                  const newPeriod = availablePeriods.find(p => p.label === e.target.value);
                  if (newPeriod) setSelectedPeriod(newPeriod);
                }}
              >
                {availablePeriods.map((p, i) => (
                  <option key={i} value={p.label}>{p.label}</option>
                ))}
              </Form.Select>
            </Col>
            <Col md={1}>
              <Button variant="outline-primary" size="sm" onClick={goToNextPeriod}>▶</Button>
            </Col>
            <Col md={3}>
              <div className="d-flex gap-2">
                <Button variant="outline-primary" size="sm" onClick={exportToExcel}>Export Excel</Button>
                <Button variant="outline-primary" size="sm" onClick={exportToPDF}>Export PDF</Button>
              </div>
            </Col>
            <Col md={4}>
              <Form.Control type="search" placeholder="Search records..." value={searchTerm} onChange={handleSearch} />
            </Col>
          </Row>

          {loading && <p className="text-primary">Loading attendance records...</p>}
          {error && <p className="text-danger">{error}</p>}

          {!loading && !error && filteredData.length === 0 && (
            <div className="text-center py-5">
              <h4 className="text-muted">No dates found for this period</h4>
            </div>
          )}

          {!loading && !error && filteredData.length > 0 && (
            <div className="table-responsive" style={{ maxHeight: "calc(100vh - 250px)", overflowY: "auto" }}>
              <table className="table table-sm table-bordered" style={{ fontSize: "14px", borderCollapse: "collapse", width: "100%" }}>
                <thead style={{ backgroundColor: "#e9ecef", color: "#495057" }}>
                  <tr>
                    <th className="py-2" style={{ width: "180px" }}>Date</th>
                    <th className="py-2" style={{ width: "100px" }}>In</th>
                    <th className="py-2" style={{ width: "100px" }}>Out</th>
                    <th className="py-2" style={{ width: "140px" }}>Worked Hours</th>
                    <th className="py-2" style={{ width: "120px" }}>Break</th>
                    <th className="py-2">Details</th>
                    <th className="py-2" style={{ width: "60px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((item, index) => {
                    const future = isFutureDate(item.date);
                    const today = isToday(item.date);
                    const hasRecord = !item._isGenerated;
                    const isWeekend = moment(item.date).day() === 0 || moment(item.date).day() === 6;
                    const isPaidHoliday = hasRecord && item.status === "holiday" && item.leaveType === "paid";

                    return (
                      <tr
                        key={item._id || index}
                        style={{
                          backgroundColor: future ? "#f8f9fa" :
                                          item.status === "absent" ? "#fff5f5" :
                                          item.status === "leave" ? "#fff8f0" :
                                          item.status === "holiday" ? "#f3f0ff" :
                                          item.status === "weekoff" ? "#f8f9fa" :
                                          today ? "#e7f3ff" : "#fff",
                          opacity: future ? 0.6 : 1,
                        }}
                      >
                        {/* Date Column */}
                        <td style={{ verticalAlign: "middle" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            {today && (
                              <span
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  backgroundColor: "#0d6efd",
                                  borderRadius: "50%",
                                  display: "inline-block",
                                }}
                              />
                            )}
                            <div>
                              <span style={{ fontWeight: "600", color: "#495057", fontSize: "13px" }}>
                                {moment(item.date).format("dddd D MMM")}
                              </span>
                              {today && (
                                <span style={{
                                  fontSize: "10px",
                                  color: "#0d6efd",
                                  marginLeft: "6px",
                                  fontWeight: "600",
                                }}>
                                  TODAY
                                </span>
                              )}
                              {/* NEW: Public Holiday indicator */}
                              {item.isPublicHoliday && (
                                <div style={{ marginTop: "2px" }}>
                                  <span
                                    style={{
                                      backgroundColor: "#6f42c1",
                                      color: "#fff",
                                      padding: "1px 6px",
                                      borderRadius: "3px",
                                      fontSize: "9px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {item.holidayName || "PUBLIC HOLIDAY"}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        </td>

                        {/* In Column */}
                        <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                          {hasRecord && item.status === "present"
                            ? <span style={{ fontWeight: "500" }}>{formatTimeInUK(item.checkIn)}</span>
                            : <span style={{ color: "#adb5bd" }}>—</span>
                          }
                        </td>

                        {/* Out Column */}
                        <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                          {hasRecord && item.status === "present"
                            ? (item.checkOut
                                ? <span style={{ fontWeight: "500" }}>{formatTimeInUK(item.checkOut)}</span>
                                : <span style={{ color: "#28a745", fontWeight: "500" }}>At Work</span>
                              )
                            : <span style={{ color: "#adb5bd" }}>—</span>
                          }
                        </td>

                        {/* Worked Hours Column - INCLUDES PAID HOLIDAY */}
                        <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                          {hasRecord && item.status === "present" ? (
                            <div>
                              <span style={{ fontWeight: "600", color: "#0d6efd" }}>
                                {item.workedHours || "0"} hrs
                              </span>
                              {/* NEW: Show public holiday hours if any */}
                              {item.publicHolidayHours > 0 && (
                                <div style={{ fontSize: "11px", color: "#6f42c1", fontWeight: "600", marginTop: "2px" }}>
                                  +{item.publicHolidayHours} PH hrs
                                </div>
                              )}
                            </div>
                          ) : isPaidHoliday ? (
                            <div>
                              <span
                                style={{
                                  fontWeight: "600",
                                  color: "#6f42c1",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  justifyContent: "center",
                                }}
                                title="Paid Holiday – Shift hours counted"
                              >
                                {item.workedHours || "0"} hrs
                                <span
                                  style={{
                                    fontSize: "9px",
                                    backgroundColor: "#6f42c1",
                                    color: "#fff",
                                    padding: "1px 5px",
                                    borderRadius: "3px",
                                    fontWeight: "700",
                                  }}
                                >
                                  HOL
                                </span>
                              </span>
                              {item.publicHolidayHours > 0 && (
                                <div style={{ fontSize: "11px", color: "#6f42c1", fontWeight: "600", marginTop: "2px" }}>
                                  +{item.publicHolidayHours} PH hrs
                                </div>
                              )}
                            </div>
                          ) : item.publicHolidayHours > 0 ? (
                            <span style={{ fontWeight: "600", color: "#6f42c1" }}>
                              {item.publicHolidayHours} PH hrs
                            </span>
                          ) : (
                            <span style={{ color: "#adb5bd" }}>—</span>
                          )}
                        </td>

                        {/* Break Column – Only the "Details" button */}
                        <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                          {hasRecord && item.status === "present"
                            ? renderBreakButton(item)
                            : <span style={{ color: "#adb5bd", fontSize: "12px" }}>—</span>
                          }
                        </td>

                        {/* Details Column - Status Badges + Add Hours button */}
                        <td style={{ verticalAlign: "middle" }}>
                          {hasRecord ? (
                            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "4px" }}>
                              {item.status === "leave" && item.leaveType === "sick" ? (
                                <>
                                  <span
                                    style={{
                                      backgroundColor: "#ffc107",
                                      color: "#856404",
                                      padding: "4px 12px",
                                      borderRadius: "4px",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      textTransform: "uppercase",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    ⚠️ Sickness
                                  </span>
                                  <span
                                    style={{
                                      backgroundColor: "#fff",
                                      color: "#28a745",
                                      border: "1px solid #28a745",
                                      padding: "4px 12px",
                                      borderRadius: "4px",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    PAID
                                  </span>
                                </>
                              ) : (
                                <>
                                  {getStatusBadge(item.status, item.leaveType)}
                                  {item.leaveType && item.leaveType !== "sick" && getLeaveTypeBadge(item.leaveType)}
                                </>
                              )}

                              {/* NEW: Add Hours button for Public Holiday */}
                              {item.isPublicHoliday && canManageStatus && !future && (
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  style={{
                                    fontSize: "11px",
                                    padding: "2px 8px",
                                    marginLeft: "6px",
                                    borderRadius: "4px",
                                  }}
                                  onClick={() => handleOpenPublicHolidayHoursModal(item)}
                                >
                                  <FaPlus size={9} className="me-1" />
                                  {item.publicHolidayHours > 0 ? "Edit Hours" : "Add Hours"}
                                </Button>
                              )}
                            </div>
                          ) : !future ? (
                            <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                              {canManageStatus && (
                                <Button
                                  variant="light"
                                  size="sm"
                                  onClick={() => handleOpenMarkAbsenceModal(item.date)}
                                  style={{
                                    border: "1px dashed #adb5bd",
                                    color: "#6c757d",
                                    fontSize: "12px",
                                    padding: "4px 12px",
                                    borderRadius: "4px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.borderColor = "#0d6efd";
                                    e.target.style.color = "#0d6efd";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.borderColor = "#adb5bd";
                                    e.target.style.color = "#6c757d";
                                  }}
                                >
                                  <FaPlus size={10} /> Add Status
                                </Button>
                              )}

                              {/* NEW: Add Hours even on blank public holiday rows */}
                              {item.isPublicHoliday && canManageStatus && (
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  style={{
                                    fontSize: "11px",
                                    padding: "2px 8px",
                                    borderRadius: "4px",
                                  }}
                                  onClick={() => handleOpenPublicHolidayHoursModal(item)}
                                >
                                  <FaPlus size={9} className="me-1" />
                                  {item.publicHolidayHours > 0 ? "Edit Hours" : "Add Hours"}
                                </Button>
                              )}
                            </div>
                          ) : (
                            <span style={{ color: "#adb5bd", fontSize: "12px" }}>Upcoming</span>
                          )}
                        </td>

                        {/* Actions Column */}
                        <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                          {hasRecord && !future && (
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="link"
                                size="sm"
                                id={`dropdown-${item._id}`}
                                style={{ color: "#6c757d", padding: "2px 6px" }}
                              >
                                <FaEllipsisV />
                              </Dropdown.Toggle>
                              <Dropdown.Menu align="end">
                                {canManageStatus && item.status !== "present" && (
                                  <>
                                    <Dropdown.Item onClick={() => {
                                      setSelectedDateForAbsence(item.date);
                                      const isHoliday = item.status === "holiday";
                                      setAbsenceFormData({
                                        status: item.status || "absent",
                                        leaveType: isHoliday ? "paid" : (item.leaveType || ""),
                                        leaveReason: item.leaveReason || "",
                                      });
                                      setShowMarkAbsenceModal(true);
                                    }}>
                                      <FaEdit className="me-2" style={{ color: "#fd7e14" }} /> Edit Status
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                  </>
                                )}

                                {canManageStatus && item.status === "present" && (
                                  <>
                                    <Dropdown.Item onClick={() => {
                                      setSelectedDateForAbsence(item.date);
                                      setAbsenceFormData({
                                        status: "absent",
                                        leaveType: "",
                                        leaveReason: "",
                                      });
                                      setShowMarkAbsenceModal(true);
                                    }}>
                                      <FaEdit className="me-2" style={{ color: "#dc3545" }} /> Mark Absent/Leave
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                  </>
                                )}

                                <Dropdown.Item as={Link} to={`/edit-atd/${item._id}`}>
                                  <FaEdit className="me-2" /> Edit Times
                                </Dropdown.Item>

                                <Dropdown.Item onClick={() => handleShowModal(item)}>
                                  <MdAccessTime className="me-2" /> View Details
                                </Dropdown.Item>

                                {item.lateMinutes > 0 && (
                                  <Dropdown.Item onClick={() => handleOpenLateApprovalForm(item)}>
                                    {item.lateApproved ? <FaCheckCircle className="me-2" /> : <FaWpforms className="me-2" />} Late Approval
                                  </Dropdown.Item>
                                )}

                                {item.earlyCloseMinutes > 0 && (
                                  <Dropdown.Item onClick={() => handleOpenEarlyLeaveApprovalForm(item)}>
                                    {item.earlyCloseApproved ? <FaCheckCircle className="me-2" /> : <FaWpforms className="me-2" />} Early Leave
                                  </Dropdown.Item>
                                )}

                                {item.extraMinutes > 0 && (
                                  <Dropdown.Item onClick={() => handleOpenOvertimeApprovalForm(item)}>
                                    {item.overtimeApproved ? <FaCheckCircle className="me-2" /> : <FaWpforms className="me-2" />} Overtime
                                  </Dropdown.Item>
                                )}

                                {lateDocs[item._id] && (
                                  <Dropdown.Item onClick={() => handleViewDocument(lateDocs[item._id], item, "late")}>
                                    <IoEye className="me-2" /> Late Doc
                                  </Dropdown.Item>
                                )}

                                {earlyCloseDocs[item._id] && (
                                  <Dropdown.Item onClick={() => handleViewDocument(earlyCloseDocs[item._id], item, "earlyClose")}>
                                    <IoEye className="me-2" /> Early Doc
                                  </Dropdown.Item>
                                )}

                                {overtimeDocs[item._id] && (
                                  <Dropdown.Item onClick={() => handleViewDocument(overtimeDocs[item._id], item, "overtime")}>
                                    <IoEye className="me-2" /> Overtime Doc
                                  </Dropdown.Item>
                                )}

                                <Dropdown.Divider />

                                <Dropdown.Item className="text-danger" onClick={() => handleDeleteClick(item)}>
                                  <MdDelete className="me-2" /> Delete
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>

                {/* FOOTER WITH TOTALS */}
                <tfoot style={{ color: "#495057", fontWeight: "bold" }}>
                  {/* Present Hours */}
                  <tr style={{ backgroundColor: "#e9ecef" }}>
                    <td colSpan="3" style={{ textAlign: "right", padding: "10px 12px" }}>
                      Total Worked Hours:
                    </td>
                    <td style={{ textAlign: "center", padding: "10px 12px", color: "#0d6efd" }}>
                      {totalWorkedHours.toFixed(2)} hrs
                    </td>
                    <td colSpan="3" style={{ backgroundColor: "#e9ecef" }}></td>
                  </tr>

                  {/* Paid Holiday Hours */}
                  {totalPaidHolidayHours > 0 && (
                    <tr style={{ backgroundColor: "#f3f0ff" }}>
                      <td colSpan="3" style={{ textAlign: "right", padding: "10px 12px" }}>
                        Total Paid Holiday Hours:
                      </td>
                      <td style={{ textAlign: "center", padding: "10px 12px", color: "#6f42c1" }}>
                        {totalPaidHolidayHours.toFixed(2)} hrs
                      </td>
                      <td colSpan="3" style={{ backgroundColor: "#f3f0ff" }}></td>
                    </tr>
                  )}

                  {/* NEW: Public Holiday Hours */}
                  {totalPublicHolidayHours > 0 && (
                    <tr style={{ backgroundColor: "#e8e0ff" }}>
                      <td colSpan="3" style={{ textAlign: "right", padding: "10px 12px" }}>
                        Total Public Holiday Hours:
                      </td>
                      <td style={{ textAlign: "center", padding: "10px 12px", color: "#6f42c1", fontWeight: "700" }}>
                        {totalPublicHolidayHours.toFixed(2)} hrs
                      </td>
                      <td colSpan="3" style={{ backgroundColor: "#e8e0ff" }}></td>
                    </tr>
                  )}

                  {/* Grand Total */}
                  <tr
                    style={{
                      backgroundColor: "#d1e7dd",
                      borderTop: "2px solid #0d6efd",
                    }}
                  >
                    <td
                      colSpan="3"
                      style={{
                        textAlign: "right",
                        padding: "12px",
                        fontSize: "15px",
                        fontWeight: "800",
                        color: "#0a3622",
                      }}
                    >
                      Grand Total Hours:
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        padding: "12px",
                        color: "#0a3622",
                        fontWeight: "800",
                        fontSize: "16px",
                      }}
                    >
                      {grandTotalHours.toFixed(2)} hrs
                    </td>
                    <td colSpan="3" style={{ backgroundColor: "#d1e7dd" }}></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* ========== ALL EXISTING MODALS ========== */}
      {/* Attendance Details Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Attendance Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3 p-3 rounded" style={{ backgroundColor: "#f8f9fa" }}>
            <Row>
              <Col md={6}>
                <p className="mb-1"><strong>User ID:</strong> {modalData.userId || employee.userId}</p>
                <p className="mb-1"><strong>Name:</strong> {modalData.userName || employee.name}</p>
                <p className="mb-0"><strong>Department:</strong> {modalData.department || "N/A"}</p>
              </Col>
              <Col md={6}>
                <p className="mb-1"><strong>Date:</strong> {modalData.date ? moment(modalData.date).format("dddd, DD MMM YYYY") : "N/A"}</p>
                <p className="mb-1"><strong>Status:</strong> {getStatusBadge(modalData.status, modalData.leaveType)}</p>
                {modalData.leaveType && modalData.leaveType !== "sick" && getLeaveTypeBadge(modalData.leaveType)}
              </Col>
            </Row>
          </div>
          <Row className="mb-3">
            <Col md={4} className="text-center">
              <div className="p-2 rounded" style={{ backgroundColor: "#e7f3ff" }}>
                <small className="text-muted">Check In</small>
                <div className="h5 mb-0" style={{ color: "#0d6efd" }}>
                  {modalData.checkIn ? formatTimeInUK(modalData.checkIn) : "—"}
                </div>
              </div>
            </Col>
            <Col md={4} className="text-center">
              <div className="p-2 rounded" style={{ backgroundColor: "#e7f3ff" }}>
                <small className="text-muted">Check Out</small>
                <div className="h5 mb-0" style={{ color: "#0d6efd" }}>
                  {modalData.checkOut ? formatTimeInUK(modalData.checkOut) : "—"}
                </div>
              </div>
            </Col>
            <Col md={4} className="text-center">
              <div className="p-2 rounded" style={{ backgroundColor: "#d4edda" }}>
                <small className="text-muted">Worked Hours</small>
                <div className="h5 mb-0" style={{ color: "#28a745" }}>
                  {modalData.workedHours || "0"} hrs
                </div>
              </div>
            </Col>
          </Row>

          {/* NEW: Public Holiday Hours in details */}
          {modalData.publicHolidayHours > 0 && (
            <div className="mb-3 p-3 rounded" style={{ backgroundColor: "#f3f0ff", borderLeft: "4px solid #6f42c1" }}>
              <strong style={{ color: "#6f42c1" }}>Public Holiday Hours:</strong>{" "}
              <span style={{ fontWeight: "700", fontSize: "16px" }}>{modalData.publicHolidayHours} hrs</span>
            </div>
          )}

          <div className="mb-3">
            <h6 style={{ color: "#495057", fontWeight: "600", borderBottom: "2px solid #dee2e6", paddingBottom: "8px" }}>
              <FaClock className="me-2" style={{ color: "#0d6efd" }} />
              Break Information
            </h6>
            {modalData.isAutoBreakDeducted ? (
              <div className="ps-3">
                <p className="mb-2 text-muted" style={{ fontSize: "14px" }}>
                  <em>Auto-deducted (no manual break clocked)</em>
                </p>
                <Row>
                  <Col md={3} className="text-center">
                    <div className="p-2 rounded" style={{ backgroundColor: "#d4edda" }}>
                      <small className="text-muted">Paid</small>
                      <div className="h5 mb-0 text-success">
                        {modalData.totalPaidBreakMinutes || 0}m
                      </div>
                    </div>
                  </Col>
                  <Col md={3} className="text-center">
                    <div className="p-2 rounded" style={{ backgroundColor: "#fff3cd" }}>
                      <small className="text-muted">Unpaid</small>
                      <div className="h5 mb-0" style={{ color: "#856404" }}>
                        {modalData.totalUnpaidBreakMinutes || 0}m
                      </div>
                    </div>
                  </Col>
                  <Col md={3} className="text-center">
                    <div className="p-2 rounded" style={{ backgroundColor: "#f8d7da" }}>
                      <small className="text-muted">Excess</small>
                      <div className="h5 mb-0 text-danger">
                        {modalData.totalExcessUnpaidMinutes || 0}m
                      </div>
                    </div>
                  </Col>
                  <Col md={3} className="text-center">
                    <div className="p-2 rounded" style={{ backgroundColor: "#f8f9fa", border: "1px solid #dc3545" }}>
                      <small className="text-muted">Deducted</small>
                      <div className="h5 mb-0 text-danger">
                        -{modalData.breakDeductionMinutes || 0}m
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            ) : ((modalData.totalBreakMinutes || 0) +
                 (modalData.totalPaidBreakMinutes || 0) +
                 (modalData.totalUnpaidBreakMinutes || 0)) > 0 ? (
              <div className="ps-3">
                <p className="mb-2 text-muted" style={{ fontSize: "14px" }}>
                  <em>
                    Break recorded
                    {modalData.autoTopUpUnpaidMinutes > 0 &&
                      ` (incl. ${modalData.autoTopUpUnpaidMinutes}m unused unpaid break added)`}
                  </em>
                </p>
                <Row>
                  <Col md={3} className="text-center">
                    <div className="p-2 rounded" style={{ backgroundColor: "#d4edda" }}>
                      <small className="text-muted">Total</small>
                      <div className="h5 mb-0 text-success">
                        {modalData.totalBreakMinutes || 0}m
                      </div>
                    </div>
                  </Col>
                  <Col md={3} className="text-center">
                    <div className="p-2 rounded" style={{ backgroundColor: "#d4edda" }}>
                      <small className="text-muted">Paid</small>
                      <div className="h5 mb-0 text-success">
                        {modalData.totalPaidBreakMinutes || 0}m
                      </div>
                    </div>
                  </Col>
                  <Col md={3} className="text-center">
                    <div className="p-2 rounded" style={{ backgroundColor: "#fff3cd" }}>
                      <small className="text-muted">Unpaid</small>
                      <div className="h5 mb-0" style={{ color: "#856404" }}>
                        {modalData.totalUnpaidBreakMinutes || 0}m
                      </div>
                    </div>
                  </Col>
                  <Col md={3} className="text-center">
                    <div className="p-2 rounded" style={{ backgroundColor: "#f8f9fa", border: "1px solid #dc3545" }}>
                      <small className="text-muted">Deducted</small>
                      <div className="h5 mb-0 text-danger">
                        -{modalData.breakDeductionMinutes || 0}m
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            ) : (
              <p className="text-muted ps-3">No break recorded</p>
            )}
          </div>
          <div className="mb-3">
            <h6 style={{ color: "#495057", fontWeight: "600", borderBottom: "2px solid #dee2e6", paddingBottom: "8px" }}>
              Discrepancy Details
            </h6>
            <Row className="ps-3">
              <Col md={4}>
                <p className="mb-1"><strong>Late:</strong> {modalData.lateMinutes || 0} min</p>
                <p className="mb-0 text-muted" style={{ fontSize: "13px" }}>
                  {modalData.lateReason || "No reason provided"}
                </p>
              </Col>
              <Col md={4}>
                <p className="mb-1"><strong>Early Close:</strong> {modalData.earlyCloseMinutes || 0} min</p>
                <p className="mb-0 text-muted" style={{ fontSize: "13px" }}>
                  {modalData.earlyCloseReason || "No reason provided"}
                </p>
              </Col>
              <Col md={4}>
                <p className="mb-1"><strong>Overtime:</strong> {modalData.extraMinutes || 0} min</p>
                <p className="mb-0 text-muted" style={{ fontSize: "13px" }}>
                  {modalData.overtimeReason || "No reason provided"}
                </p>
              </Col>
            </Row>
          </div>
          {modalData.leaveReason && (
            <div className="mb-3">
              <h6 style={{ color: "#495057", fontWeight: "600", borderBottom: "2px solid #dee2e6", paddingBottom: "8px" }}>
                Absence Details
              </h6>
              <p className="mb-1 ps-3"><strong>Reason:</strong> {modalData.leaveReason}</p>
              {modalData.markedBy && <p className="mb-0 ps-3"><strong>Marked By:</strong> {modalData.markedBy}</p>}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
        </Modal.Footer>
      </Modal>

      {/* Document View Modal */}
      <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="w-100 d-flex justify-content-between align-items-center">
            <span>View Document</span>
            <div>
              {selectedDocUrl && <Button variant="outline-success" className="me-2" onClick={handleDownload}><FaDownload /></Button>}
              <Button variant="outline-warning" onClick={() => fileInputRef.current?.click()}><TbReplaceFilled /></Button>
              <input ref={fileInputRef} type="file" accept=".jpg,.png,.pdf" style={{ display: "none" }} onChange={handleFileReplace} />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {selectedDocUrl ? (
            selectedDocUrl.endsWith(".pdf") ? (
              <iframe src={selectedDocUrl} width="100%" height="500px" style={{ border: "none" }} title="PDF" />
            ) : (
              <img src={selectedDocUrl} alt="Document" style={{ maxWidth: "100%", height: "auto" }} />
            )
          ) : (
            <p style={{ color: "red", fontWeight: "bold" }}>No document available</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowViewModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      {/* Break History Modal */}
      <Modal
        show={showBreakTimesModal}
        onHide={() => setShowBreakTimesModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton style={{ backgroundColor: "#007bff", color: "#fff" }}>
          <Modal.Title style={{ color: "#fff" }}>
            <FaClock className="me-2" />
            Break History – {selectedBreakItem?.userName || employee.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "#f8f9fa", borderRadius: "0 0 10px 10px" }}>
          {renderBreakHistoryBody()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBreakTimesModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Late / Early / Overtime Approval Modals – unchanged */}
      {/* (keeping them exactly as you had them) */}

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the attendance record for{" "}
          {recordToDelete && moment(recordToDelete.date).format("YYYY-MM-DD")}?
          <br />
          <strong>This action cannot be undone.</strong>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleDeleteRecord}>Delete</Button>
        </Modal.Footer>
      </Modal>

      {/* Mark Absence / Leave / Holiday / None Modal – unchanged */}
      <Modal
        show={showMarkAbsenceModal}
        onHide={handleCloseMarkAbsenceModal}
        centered
        backdrop="static"
      >
        <Modal.Header
          closeButton
          style={{
            background: "linear-gradient(135deg, #0d6efd, #0056b3)",
            color: "#fff",
            border: "none",
          }}
        >
          <Modal.Title style={{ fontWeight: "700" }}>
            <FaEdit className="me-2" />
            {modalData?.status && modalData.status !== "present"
              ? "Edit Attendance Status"
              : "Mark Attendance Status"
            }
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "25px" }}>
          <div
            className="mb-4 p-3 rounded"
            style={{ backgroundColor: "#f8f9fa", borderLeft: "4px solid #0d6efd" }}
          >
            <p className="mb-1"><strong>Employee:</strong> {employee.name}</p>
            <p className="mb-1"><strong>User ID:</strong> {employee.userId}</p>
            <p className="mb-0"><strong>Date:</strong> {selectedDateForAbsence ? moment(selectedDateForAbsence).format("dddd, DD MMM YYYY") : selectedPeriod.label}</p>
          </div>

          <Form>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: "600", color: "#495057" }}>
                Status <span style={{ color: "#dc3545" }}>*</span>
              </Form.Label>
              <Form.Select
                value={absenceFormData.status}
                onChange={(e) => handleAbsenceFormChange("status", e.target.value)}
                style={{
                  borderRadius: "8px",
                  border: "2px solid #dee2e6",
                  padding: "10px",
                  fontSize: "14px",
                }}
              >
                <option value="absent">Absent</option>
                <option value="leave">Leave</option>
                <option value="holiday">Holiday</option>
                <option value="weekoff">Week Off</option>
                <option value="none">None (Clear Status)</option>
              </Form.Select>
              {absenceFormData.status === "none" && (
                <Form.Text style={{ color: "#dc3545", fontSize: "12px" }}>
                  ⚠️ This will delete the attendance record for this date so you can add fresh timings.
                </Form.Text>
              )}
            </Form.Group>

            {absenceFormData.status === "leave" && (
              <Form.Group className="mb-3">
                <Form.Label style={{ fontWeight: "600", color: "#495057" }}>
                  Leave Type <span style={{ color: "#dc3545" }}>*</span>
                </Form.Label>
                <Form.Select
                  value={absenceFormData.leaveType}
                  onChange={(e) => handleAbsenceFormChange("leaveType", e.target.value)}
                  style={{
                    borderRadius: "8px",
                    border: "2px solid #dee2e6",
                    padding: "10px",
                    fontSize: "14px",
                  }}
                >
                  <option value="">-- Select Leave Type --</option>
                  <option value="paid">Paid Leave</option>
                  <option value="unpaid">Unpaid Leave</option>
                  <option value="sick">Sick Leave</option>
                  <option value="annual">Annual Leave</option>
                  <option value="casual">Casual Leave</option>
                </Form.Select>
              </Form.Group>
            )}

            {absenceFormData.status === "holiday" && (
              <Form.Group className="mb-3">
                <Form.Label style={{ fontWeight: "600", color: "#495057" }}>
                  Holiday Type
                </Form.Label>
                <Form.Control
                  type="text"
                  value="Paid Holiday"
                  disabled
                  style={{
                    borderRadius: "8px",
                    border: "2px solid #dee2e6",
                    padding: "10px",
                    fontSize: "14px",
                    backgroundColor: "#e7f3ff",
                    color: "#0d6efd",
                    fontWeight: "600",
                  }}
                />
                <Form.Text className="text-muted" style={{ fontSize: "12px" }}>
                  Holidays are always paid. Shift hours will be added to total hours.
                </Form.Text>
              </Form.Group>
            )}

            {absenceFormData.status !== "none" && (
              <Form.Group className="mb-3">
                <Form.Label style={{ fontWeight: "600", color: "#495057" }}>
                  Reason / Notes
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter reason for absence, leave, or holiday..."
                  value={absenceFormData.leaveReason}
                  onChange={(e) => handleAbsenceFormChange("leaveReason", e.target.value)}
                  style={{
                    borderRadius: "8px",
                    border: "2px solid #dee2e6",
                    padding: "10px",
                    fontSize: "14px",
                    resize: "none",
                  }}
                />
              </Form.Group>
            )}
          </Form>
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #e9ecef", padding: "15px 25px" }}>
          <Button
            variant="light"
            onClick={handleCloseMarkAbsenceModal}
            style={{
              border: "2px solid #dee2e6",
              fontWeight: "600",
              padding: "8px 20px",
              borderRadius: "8px",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleMarkAbsence}
            disabled={markingAbsence || (absenceFormData.status === "leave" && !absenceFormData.leaveType)}
            style={{
              background: absenceFormData.status === "none"
                ? "linear-gradient(135deg, #dc3545, #b02a37)"
                : "linear-gradient(135deg, #0d6efd, #0056b3)",
              border: "none",
              fontWeight: "600",
              padding: "8px 25px",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(13,110,253,0.3)",
            }}
          >
            {markingAbsence ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Saving...
              </>
            ) : (
              <>
                <FaCheckCircle className="me-2" />
                {absenceFormData.status === "none"
                  ? "Clear Status"
                  : modalData?.status && modalData.status !== "present"
                    ? "Update Status"
                    : "Mark Status"
                }
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ========== NEW: Public Holiday Hours Modal ========== */}
      <Modal
        show={showPublicHolidayHoursModal}
        onHide={() => setShowPublicHolidayHoursModal(false)}
        centered
      >
        <Modal.Header
          closeButton
          style={{
            background: "linear-gradient(135deg, #6f42c1, #5a32a3)",
            color: "#fff",
          }}
        >
          <Modal.Title style={{ fontWeight: "700" }}>
            <FaClock className="me-2" />
            Add Public Holiday Hours
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "25px" }}>
          <div
            className="mb-4 p-3 rounded"
            style={{ backgroundColor: "#f3f0ff", borderLeft: "4px solid #6f42c1" }}
          >
            <p className="mb-1"><strong>Employee:</strong> {employee.name}</p>
            <p className="mb-1"><strong>Date:</strong> {publicHolidayHoursForm.date ? moment(publicHolidayHoursForm.date).format("dddd, DD MMM YYYY") : ""}</p>
            <p className="mb-0"><strong>Holiday:</strong> {publicHolidayHoursForm.holidayName || "Public Holiday"}</p>
          </div>

          <Form.Group className="mb-3">
            <Form.Label style={{ fontWeight: "600" }}>
              Hours to Add <span style={{ color: "#dc3545" }}>*</span>
            </Form.Label>
            <Form.Control
              type="number"
              min="0"
              step="0.25"
              placeholder="e.g. 7.5"
              value={publicHolidayHoursForm.hours}
              onChange={(e) =>
                setPublicHolidayHoursForm((prev) => ({
                  ...prev,
                  hours: e.target.value,
                }))
              }
              style={{
                borderRadius: "8px",
                border: "2px solid #dee2e6",
                padding: "10px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            />
            <Form.Text className="text-muted">
              These hours will be added to the Grand Total (on top of any clock-in/out hours).
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => setShowPublicHolidayHoursModal(false)}
            style={{ border: "2px solid #dee2e6", fontWeight: "600" }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSavePublicHolidayHours}
            disabled={savingPublicHolidayHours}
            style={{
              background: "linear-gradient(135deg, #6f42c1, #5a32a3)",
              border: "none",
              fontWeight: "600",
            }}
          >
            {savingPublicHolidayHours ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Saving...
              </>
            ) : (
              <>
                <FaCheckCircle className="me-2" />
                Save Hours
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </EditAtdLayout>
  );
}